/**
 * Question Set content type
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    questionSetSchema,
    defaultQuestionSetConfig,
    defaultQuestionSetData,
    type QuestionSetContent,
    type QuestionSetData,
    type QuestionSetItem,
    type QuestionSetConfig,
    type QuestionSetScoringConfig,
    type QuestionSetLayoutConfig,
    type QuestionSetSplitRatio,
    type QuestionSetElementType,
    type PageElementData,
} from './schema';

export {
    normalizeQuestionSetPanelArrangement,
    normalizeQuestionSetLayoutConfig,
    type QuestionSetPanelArrangement,
} from './layout';

export {
    QuestionSetEdit,
    type QuestionSetEditProps,
} from './QuestionSetEdit';

export {
    QuestionSetPlayer,
    type QuestionSetPlayerProps,
    type QuestionSetResults,
    type QuestionSetItemResult,
} from './QuestionSetPlayer';

export {
    questionSetContentGrader,
    gradeQuestionSet,
    validateQuestionSetAnswer,
    countQuestionSetQuestions,
    questionSetQuestionCounter,
} from './scorer';

export { questionSetSchema as default } from './schema';

export { questionSetValidator } from './validator';
